import { getCaseVoucherTables } from '../economy/case-vouchers/tables.js';
import { Entity } from '../index.js';
import { PropertyDataType, caseGroupScopeIds, } from '../properties/index.js';
import { TemplateMention, TemplateType } from './index.js';
const BasicTemplateMentionSuggestions = [
    TemplateMention.FINANCIALS_PRICIPAL,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES,
    TemplateMention.FINANCIALS_ADMINISTRATION_COSTS,
    TemplateMention.FINANCIALS_COMPENSATION_FEES,
    TemplateMention.FINANCIALS_INTERESTS,
    TemplateMention.FINANCIALS_INTEREST_RATE,
    TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS,
    TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE,
    TemplateMention.PAYMENT_PLAN_FIRST_DATE,
    TemplateMention.PAYMENT_PLAN_LAST_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DEADLINE,
    TemplateMention.PaymentPlanApr,
    TemplateMention.PAYMENT_PLAN_YEARLY_COSTS,
    TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST,
    TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_LAST_DATE,
    TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT,
    TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE,
    TemplateMention.PAYMENT_PLAN_ENTRY_DATE,
    TemplateMention.PAYMENT_PLAN_CREATION_DATE,
    TemplateMention.TOTAL_DEBT,
    TemplateMention.OVERPAYMENT,
    TemplateMention.CURRENCY,
    TemplateMention.PRINCIPAL_REFERENECE_IDS,
    TemplateMention.ACCORD_TEN_PERCENT,
    TemplateMention.ACCORD_TWENTY_PERCENT,
    TemplateMention.ACCORD_THIRTY_PERCENT,
    TemplateMention.ACCORD_FORTY_PERCENT,
    TemplateMention.ACCORD_FIFTY_PERCENT,
    TemplateMention.ACCORD_SIXTY_PERCENT,
    TemplateMention.ACCORD_SEVENTY_PERCENT,
    TemplateMention.ACCORD_EIGHTY_PERCENT,
    TemplateMention.ACCORD_NINETY_PERCENT,
    TemplateMention.IF_IS_COMPANY,
    TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED,
    TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS,
    TemplateMention.IF_CASE_HAS_REMINDER_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_FEES,
    TemplateMention.IF_CASE_HAS_COLLECTION_COSTS,
    TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS,
    TemplateMention.IF_CASE_HAS_PROCESSRENTE,
    TemplateMention.IF_CASE_HAS_FIXED_INTEREST,
    TemplateMention.IF_CASE_HAS_YEARLT_INTEREST,
    TemplateMention.IF_CASE_HAS_DEPOSIT,
    TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS,
    TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS,
    TemplateMention.DATE,
    TemplateMention.DATE_IN_THREE_DAYS,
    TemplateMention.DATE_IN_SIX_DAYS,
    TemplateMention.DATE_IN_TEN_DAYS,
    TemplateMention.DATE_IN_ELEVEN_DAYS,
    TemplateMention.DATE_IN_TWELVE_DAYS,
    TemplateMention.DATE_IN_FOURTEEN_DAYS,
    TemplateMention.DATE_IN_SEVENTEEN_DAYS,
    TemplateMention.DATE_IN_THIRTY_DAYS,
    TemplateMention.PREVIOUS_THREE_YEARS,
    TemplateMention.DEPOSIT,
    TemplateMention.DEPOSITS_TO_COLLECTOR,
    TemplateMention.DEPOSITS_TO_CREDITOR,
    TemplateMention.INTEREST_PAID_LAST_YEAR,
    TemplateMention.CONTACT_NAME,
    TemplateMention.DEBTOR_NAME,
    TemplateMention.DEBTOR_FIRST_NAME,
    TemplateMention.CONTACT_ADDRESS,
    TemplateMention.CONTACT_COADDRESS,
    TemplateMention.CONTACT_ZIPCODE,
    TemplateMention.CONTACT_CITY,
    TemplateMention.CONTACT_COUNTRY,
    TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID,
    TemplateMention.DEBTOR_ADDRESS,
    TemplateMention.DEBTOR_COADDRESS,
    TemplateMention.DEBTOR_ZIPCODE,
    TemplateMention.DEBTOR_CITY,
    TemplateMention.DEBTOR_COUNTRY,
    TemplateMention.DEBTOR_EMAIL,
    TemplateMention.DEBTOR_PHONE,
    TemplateMention.LAST_PAYMENT_DATE,
    TemplateMention.LAST_PAYMENT_AMOUNT,
    TemplateMention.DEBTOR_SEQ_ID,
    TemplateMention.DEBTOR_CVR_AND_OR_CPR,
    TemplateMention.CREDITOR_NAME,
    TemplateMention.CASE_ID,
    TemplateMention.CASE_REFERENCE_ID,
    TemplateMention.CREDITOR_ADDRESS,
    TemplateMention.REMINDER_FEES,
    TemplateMention.COLLECTOR_PAYMENT_OPTIONS,
    TemplateMention.COLLECTOR_ACCOUNT_NUMBER,
    TemplateMention.COLLECTOR_REGISTER_NUMBER,
    TemplateMention.COLLECTOR_PHONE,
    TemplateMention.COLLECTOR_COURT_PHONE,
    TemplateMention.COLLECTOR_EMAIL,
    TemplateMention.COLLECTOR_NICKNAME,
    TemplateMention.COLLECTOR_NAME,
    TemplateMention.COLLECTOR_ADDRESS_ADDRESS,
    TemplateMention.COLLECTOR_ADDRESS_ZIP,
    TemplateMention.COLLECTOR_ADDRESS_CITY,
    TemplateMention.COLLECTOR_CVR,
    TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS,
    TemplateMention.CREDITOR_ZIPCODE,
    TemplateMention.CREDITOR_CITY,
    TemplateMention.CREDITOR_COMPANY_IDENTIFIER,
    TemplateMention.CREDITOR_IF_IS_COMPANY,
    TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED,
    TemplateMention.IF_ULTIMATE_CREDITOR,
    TemplateMention.CASE_CREDITOR_NAME,
    TemplateMention.CASE_CREDITOR_ADDRESS,
    TemplateMention.CASE_CREDITOR_ZIPCODE,
    TemplateMention.CASE_CREDITOR_CITY,
    TemplateMention.CASE_CREDITOR_COMPANY_IDENTIFIER,
    TemplateMention.USER_NAME,
    TemplateMention.USER_FIRST_NAME,
    TemplateMention.IF_USER,
    TemplateMention.PAYMENT_ID,
    TemplateMention.JOURNAL_NUMBER,
    TemplateMention.GENERIC_EMAIL_SUBJECT,
    TemplateMention.COURT_NAME,
    TemplateMention.COURT_ADDRESS,
    TemplateMention.COURT_CITY,
    TemplateMention.COURT_ZIP,
    TemplateMention.COURT_EMAIL,
    TemplateMention.COURT_PHONE,
    TemplateMention.COURT_EAN,
    TemplateMention.REG_NO,
    TemplateMention.ACCOUNT_NO,
    TemplateMention.FOUNDATION_DATE,
    TemplateMention.FOUNDATION_TYPE,
    TemplateMention.LATEST_TRIBUNAL_REFERENCE,
    TemplateMention.CONDITIONAL_ELSE,
    TemplateMention.CONDITIONAL_END_IF,
];
const TemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.PAYMENT_PLAN_HTML,
    TemplateMention.PaymentPlanAmortisation,
    TemplateMention.CONTACT_ADDRESS_INLINE,
    TemplateMention.CONTACT_ADDRESS_FORMATTED,
    TemplateMention.DEBTOR_ADDRESS_INLINE,
    TemplateMention.DEBTOR_ADDRESS_FORMATTED,
    TemplateMention.DEBTOR_TABLE,
];
const LetterTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.DK_BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.OVERPAYMENT_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.PAYMENT_PLAN_STATUS_TAG,
    TemplateMention.DOCUMENTATION,
    TemplateMention.SIGN_FIELDS,
];
const EBoksTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.DK_BPK,
    TemplateMention.PAGE_BREAK,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_QR_CODE,
    TemplateMention.PAYMENT_PLAN_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LINK_QR_CODE,
    TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.PAYMENT_PLAN_STATUS_TAG,
    TemplateMention.DOCUMENTATION,
    TemplateMention.SIGN_FIELDS,
];
const SMSTemplateMentionSuggestions = [
    ...BasicTemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK,
    TemplateMention.PAYMENT_LINK,
    TemplateMention.PAYMENT_PLAN_LINK,
    TemplateMention.DEBTOR_WEB_LINK,
];
const EmailTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.SATISFACTION_BUTTONS,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.DEBTOR_WEB_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.PAYMENT_PLAN_STATUS_TAG,
    TemplateMention.DOCUMENTATION,
];
const DebtorMessageTemplateMentionSuggestions = [
    ...TemplateMentionSuggestions,
    TemplateMention.OVERPAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_LINK_A_TAG,
    TemplateMention.DEBTOR_WEB_LINK_A_TAG,
    TemplateMention.PAYMENT_PLAN_ENTRIES_TAG,
    TemplateMention.PAYMENT_PLAN_STATUS_TAG,
];
export const toEditorMentions = (suggestions) => suggestions.map((suggestion) => ({
    id: suggestion.field,
    label: suggestion.label,
    caseGroupIds: suggestion.caseGroupIds,
}));
export const getMentionSuggestions = (lang, templateType, propertyTypes, tenant) => {
    let suggestions = [];
    switch (templateType) {
        case TemplateType.LETTER:
            suggestions = LetterTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.EBOKS:
            suggestions = EBoksTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.SMS:
            suggestions = SMSTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.EMAIL:
            suggestions = EmailTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.AUTOCALL:
            // TODO: Make it's own list
            suggestions = SMSTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.CREDITOR_MESSAGE:
        case TemplateType.NOTE:
            suggestions = TemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
        case TemplateType.DEBTOR_MESSAGE:
            suggestions = DebtorMessageTemplateMentionSuggestions.map((suggestion) => ({
                label: lang.mentions[suggestion],
                description: lang.mentions[suggestion],
                example: lang.mentions[suggestion],
                field: suggestion,
                caseGroupIds: [],
            }));
            break;
    }
    // Add properties
    if (propertyTypes) {
        suggestions = [
            ...suggestions,
            ...propertyTypes.map((propertyType) => {
                const propertyPath = `properties.${propertyType.handle}`;
                const label = [Entity.Customer, Entity.Creditor].includes(propertyType.ref)
                    ? `${propertyType.label} (${lang.entities[propertyType.ref]})`
                    : propertyType.label;
                let field = '';
                switch (propertyType.type) {
                    case PropertyDataType.file:
                        field = `{{{${propertyPath}}}}`;
                        break;
                    case PropertyDataType.checkbox:
                        field = `{{#if ${propertyPath}}}`;
                        break;
                    default:
                        field = `{{${propertyPath}}}`;
                }
                return {
                    label: 
                    // Add emojis to prevent to prevent overlap with other mentions
                    propertyType.type === PropertyDataType.checkbox
                        ? `${label} ⚙️`
                        : `${label} ➕`,
                    description: propertyType.description || '-',
                    example: '',
                    field: field,
                    caseGroupIds: caseGroupScopeIds(propertyType.scopes),
                };
            }),
        ];
        if ([
            TemplateType.EBOKS,
            TemplateType.EMAIL,
            TemplateType.LETTER,
            TemplateType.CREDITOR_MESSAGE,
            TemplateType.DEBTOR_MESSAGE,
            TemplateType.NOTE,
        ].includes(templateType)) {
            const tables = getCaseVoucherTables(tenant?.settings.customCaseVoucherTables || [], lang);
            suggestions = suggestions.concat(tables.map((table) => ({
                label: `${table.name} ☰`,
                description: table.description,
                example: '',
                field: `{{{caseVoucherTables.${table.handle}}}}`,
                caseGroupIds: [],
            })));
        }
        // Document signing links
        suggestions = suggestions.concat((tenant?.settings.documentSigningLinks || []).map((documentSigningLink) => ({
            label: `${documentSigningLink.name} 🔗`,
            description: documentSigningLink.description,
            example: '',
            field: [
                TemplateType.EBOKS,
                TemplateType.EMAIL,
                TemplateType.CREDITOR_MESSAGE,
                TemplateType.DEBTOR_MESSAGE,
                TemplateType.NOTE,
            ].includes(templateType)
                ? `{{{documentSigningLinksATag.${documentSigningLink.handle}}}}`
                : `{{documentSigningLinks.${documentSigningLink.handle}}}`,
            caseGroupIds: [],
        })));
    }
    return suggestions;
};
//# sourceMappingURL=suggestions.js.map